/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";

// import { getToken } from "./common/utils";
import { getToken } from "./common/utils";

interface Auth {
  isLoggedIn: boolean;
}

interface AuthInit {
  isLoggedIn: boolean;
  loading: boolean;
  // isloggedIn: boolean;
}

export const AuthContext = React.createContext<Auth>({ isLoggedIn: false });

export function useAuth(): Auth {
  return useContext(AuthContext);
}

export function useAuthInit(): AuthInit {
  const [authInit, setAuthInit] = useState<AuthInit>({
    loading: true,
    isLoggedIn: false,
  });

  useEffect(() => {
    if (getToken() === null) {
      setAuthInit({ loading: false, isLoggedIn: false });
    } else {
      setAuthInit({ loading: false, isLoggedIn: true });
    }
    // return () => {
    //   console.log("unmount");
    // };
  }, []);

  return authInit;
}
